import { styled } from '@mui/material';

const StepperHeaderContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4)
}));

export default StepperHeaderContainer;
